(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["belleora-collection-carousel"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('belleora-collection-carousel')) {
  customElements.define('belleora-collection-carousel', class extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('.belleora-cafe__track');
      if (!this.track || this.ready) return;
      this.ready = true;
      this.update = () => {
        const max = this.track.scrollWidth - this.track.clientWidth;
        this.querySelector('[data-direction="-1"]').disabled = this.track.scrollLeft < 2;
        this.querySelector('[data-direction="1"]').disabled = this.track.scrollLeft >= max - 2;
      };
      this.querySelectorAll('[data-direction]').forEach(button => {
        button.addEventListener('click', () => {
          const card = this.track.querySelector('li');
          if (!card) return;
          const step = card.getBoundingClientRect().width + parseFloat(getComputedStyle(this.track).gap);
          this.track.scrollBy({left: step * Number(button.dataset.direction), behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});
        });
      });
      this.track.addEventListener('scroll', this.update, {passive:true});
      this.observer = new ResizeObserver(this.update);
      this.observer.observe(this.track);
      this.update();
    }
    disconnectedCallback() {
      this.observer?.disconnect();
      this.track?.removeEventListener('scroll', this.update);
      this.ready = false;
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
